export default "__VITE_ASSET__CzKhg3Sj__"